import React, { useState, useEffect } from 'react'
import AIEvaluationResultView from './AIEvaluationResultView'
import { Panel } from 'rsuite'

export default function AIEvaluationResultWidget({
  schema,
  // finalSubmitButton,
  // finalSubmitButtonText,
  shaded,
  showDetail,
  // showTimes,
  // onSubmitFinalSubmitButton = () => {},
  onCheck = () => {},
  onContinue = () => {},
  isSend,
}) {
  return (
    <>
      {schema && schema.datas?.length > 0 && (
        <Panel
          header={schema.header}
          collapsible
          defaultExpanded
          bordered
          shaded={shaded}
          style={{ marginTop: 10, marginBottom: 10 }}
        >
          <AIEvaluationResultView
            schema={schema}
            // finalSubmitButton={finalSubmitButton}
            // finalSubmitButtonText={finalSubmitButtonText}
            // onSubmitFinalSubmitButton={onSubmitFinalSubmitButton}
            onCheck={onCheck}
            onContinue={onContinue}
            showDetail={showDetail}
            // showTimes={showTimes}
            isSend={isSend}
          />
        </Panel>
      )}
    </>
  )
}
